module.exports = __webpack_public_path__ + "media/img/event/Sponsor-St-Pauls-International-College-c2761d5fc4879a5b8a3d37ed843a8bfc.jpg";